<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container
          class="warning-message"
          :class="{
            'md-input-invalid': exam.fields.weight && (exam.fields.weight > 150 || exam.fields.weight < 3)
          }"
        >
          <label>Peso (kg)</label>
          <md-input
            id="weight"
            v-model="exam.fields.weight"
            v-validate="'required'"
            v-mask="weight"
            data-vv-validate-on="none"
            name="weight"
            minlength="3"
            maxlength="6"
            title="Peso (kg)"
            placeholder="Peso (kg)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.weight"
            v-mask="weight"
            type="hidden"
          >
          <span
            v-if="exam.fields.weight && (exam.fields.weight > 150 || exam.fields.weight < 3)"
            class="md-error"
          >
            Atenção para a digitação, valor atípico
          </span>
        </md-input-container>

        <md-input-container
          class="warning-message"
          :class="{
            'md-input-invalid': exam.fields.height && (exam.fields.height > 200 || exam.fields.height < 50)
          }"
        >
          <label>Altura (cm)</label>
          <md-input
            id="height"
            v-model="exam.fields.height"
            v-validate="'required'"
            v-mask="'###'"
            data-vv-validate-on="none"
            name="height"
            min="3"
            title="Altura (cm)"
            placeholder="Altura (cm)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.height"
            v-mask="'###'"
            type="hidden"
          >
          <span
            v-if="exam.fields.height && (exam.fields.height > 200 || exam.fields.height < 50)"
            class="md-error"
          >
            Atenção para a digitação, valor atípico
          </span>
        </md-input-container>

        <md-input-container>
          <label>Creatinina na urina (mg/dL)</label>
          <md-input
            id="creatinineUrine"
            v-model="exam.fields.creatinineUrine"
            v-validate="'required'"
            v-mask="creatinineUrine"
            data-vv-validate-on="none"
            name="creatinineUrine"
            title="Creatinina na urina (mg/dL)"
            placeholder="Creatinina na urina (mg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.creatinineUrine"
            v-mask="creatinineUrine"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>Creatinina Soro (mg/dL)</label>
          <md-input
            id="serumCreatinine"
            v-model="exam.fields.serumCreatinine"
            v-validate="'required'"
            v-mask="creatinine"
            data-vv-validate-on="none"
            name="serumCreatinine"
            title="Creatinina Soro (mg/dL)"
            placeholder="Creatinina Soro (mg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.serumCreatinine"
            v-mask="creatinine"
            type="hidden"
          >
        </md-input-container>

        <md-input-container
          class="warning-message"
          :class="{
            'md-input-invalid': exam.fields.volume && (exam.fields.volume > 5000 || exam.fields.volume < 300)
          }"
        >
          <label>Volume (mL)</label>
          <md-input
            id="volume"
            v-model="exam.fields.volume"
            v-validate="'required'"
            v-mask="'#####'"
            data-vv-validate-on="none"
            name="volume"
            maxlength="5"
            title="Volume (mL)"
            placeholder="Volume (mL)"
            @keyup.enter.native="calculate()"
          />
          <span
            v-if="exam.fields.volume && (exam.fields.volume > 5000 || exam.fields.volume < 300)"
            class="md-error"
          >
            Atenção para a digitação, valor atípico
          </span>
        </md-input-container>

        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <p v-if="!exam.error">
        Resultado:
        <strong><span>{{ exam.result }}mL/min/1,73m²</span></strong>
      </p>
      <p
        v-else
        class="alert-error"
      >
        <img
          src="/static/images/icon-alert-solid.svg"
          alt="icone-alerta"
        >
        <span>Todos os campos são obrigatórios</span>
      </p>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'ClearanceCreatinina',

  data() {
    return {
      exam: {
        fields: {
          weight: null,
          height: null,
          creatinineUrine: null,
          serumCreatinine: null,
          volume: null
        },
        error: false,
        result: 0
      },
      weight: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      }),
      creatinine: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 2
      }),
      creatinineUrine: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }
  },

  methods: {
    calculate() {
      if (
        this.exam.fields.weight &&
        this.exam.fields.height &&
        this.exam.fields.volume &&
        this.exam.fields.creatinineUrine &&
        this.exam.fields.serumCreatinine
      ) {
        this.exam.error = false

        const weight = this.exam.fields.weight
        const height = this.exam.fields.height
        const volume = this.exam.fields.volume
        const creatinineUrine = this.exam.fields.creatinineUrine
        const serumCreatinine = this.exam.fields.serumCreatinine

        const volumeMinute = +Number(volume / 1440).toFixed(2)
        const sc = +Number(0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425)).toFixed(2)
        const cre = +Number((creatinineUrine * volumeMinute) / serumCreatinine).toFixed(1)
        const res = +Number((cre * 1.73) / sc).toFixed(1)

        this.exam.result = res
      } else {
        this.exam.error = true
        this.exam.result = 0
      }
    }
  }
}
</script>